module.exports = __webpack_public_path__ + "media/club_deals/your_advantages-f37f92b0.webp";